import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Filter } from '@elderbyte/ngx-starter'
import { WorkCenterService } from './work-center.service'
import { WorkCenter } from './work-center'

@Directive({
  selector: '[appWorkCenterSelect]',
})
export class WorkCenterSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject<ElderSelectComponent<WorkCenter>>(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const workCenterService = inject(WorkCenterService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'shopfloor.workcenters.workcenter'
    this.select.dataSource = workCenterService
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set facility(facility: string) {
    this.select.updateFilter(new Filter('facility', facility))
  }
}
